/* eslint-disable */
(function lightbox($, Drupal) {
  // Drupal.behaviors.audio = {
  //   attach(context) {

      let playState = 'play';
      let muteState = 'unmute';

      $("audio").each(function(index) {
        
        // Get the audio file before we repalce.
        let audioFile = $(this).find('source').attr('src');

        // Unique logic for dive in podcasts tkt#6685:
        let endPath = $(location).attr("href").split('/').pop();
        let finalAudio;
        if ($( "a[href$='1000357856']" ).length || endPath == 'dive-in-with-noaa-fisheries') {
          
          // Have a check to see if url is realtive or absolute. 
          if (audioFile.startsWith('/s3/')) {

            // Here the url is relative so append the full domain and prefix.
            finalAudio = 'https://dts.podtrac.com/redirect.mp3/' + window.location.hostname + audioFile;

          } else {
            
            // Here the url is absolute so just add prefix.
            finalAudio = audioFile.replace("https://", "https://dts.podtrac.com/redirect.mp3/");
          }
          
        } else  {
          finalAudio = audioFile;
        }

        let player = `
          <div class="audio-player-container">
            <div>
            <audio src="${finalAudio}" preload="none"></audio>
            <button class="play-icon" aria-label="Play/Pause Audio"><i class="fa-solid fa-play"></i></button>
            </div>
            <div class="palyer-center">
              <span class="current-time" class="time">0:00</span>
              <input type="range" aria-label="Audio Track" class="seek-slider" max="100" value="0">
              <span class="duration" class="time"></span>
            </div>
            <div>
              <button class="mute-icon" aria-label="Mute/Unmute Audio"><i class="fa-solid fa-volume-xmark"></i></button>
            </div>
          </div>

        `;
        $(this).replaceWith(player);

        const playIconContainer = document.getElementsByClassName('play-icon')[index];
        const audioPlayerContainer = document.getElementsByClassName('audio-player-container')[index];
        const seekSlider = document.getElementsByClassName('seek-slider')[index];
        const muteIconContainer = document.getElementsByClassName('mute-icon')[index];
        const audio = document.getElementsByTagName('audio')[index];
        const durationContainer = document.getElementsByClassName('duration')[index];
        const currentTimeContainer = document.getElementsByClassName('current-time')[index];
        let raf = null;

        let playState = 'play';
        let muteState = 'unmute';

        playIconContainer.addEventListener('click', () => {
          if(playState === 'play') {
            audio.play();
            playIconContainer.innerHTML = '<i class="fa-solid fa-pause"></i>';
            requestAnimationFrame(whilePlaying);
            playState = 'pause';
        } else {
            audio.pause();
            playIconContainer.innerHTML = '<i class="fa-solid fa-play"></i>';
            cancelAnimationFrame(raf);
            playState = 'play';
          }
        });

        muteIconContainer.addEventListener('click', () => {
          if(muteState === 'unmute') {
            audio.muted = true;
            muteState = 'mute';
            muteIconContainer.innerHTML = '<i class="fa-solid fa-volume-off"></i>';
          } else {
            audio.muted = false;
            muteState = 'unmute';
            muteIconContainer.innerHTML = '<i class="fa-solid fa-volume-xmark"></i>';
          }
        });

        const showRangeProgress = (rangeInput) => {
          if(rangeInput === seekSlider) audioPlayerContainer.style.setProperty('--seek-before-width', rangeInput.value / rangeInput.max * 100 + '%');
          else audioPlayerContainer.style.setProperty('--volume-before-width', rangeInput.value / rangeInput.max * 100 + '%');
        }

        seekSlider.addEventListener('input', (e) => {
          showRangeProgress(e.target);
        });

        /** Implementation of the functionality of the audio player */
        const calculateTime = (secs) => {
          const minutes = Math.floor(secs / 60);
          const seconds = Math.floor(secs % 60);
          const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
          return `${minutes}:${returnedSeconds}`;
        }

        const displayDuration = () => {
          durationContainer.textContent = calculateTime(audio.duration);
        }

        const setSliderMax = () => {
          seekSlider.max = Math.floor(audio.duration);
        }

        const whilePlaying = () => {
          seekSlider.value = Math.floor(audio.currentTime);
          currentTimeContainer.textContent = calculateTime(seekSlider.value);
          audioPlayerContainer.style.setProperty('--seek-before-width', `${seekSlider.value / seekSlider.max * 100}%`);
          raf = requestAnimationFrame(whilePlaying);
        }

        if (audio.readyState > 0) {
          displayDuration();
          setSliderMax();
        } else {
          audio.addEventListener('loadedmetadata', () => {
            displayDuration();
            setSliderMax();
          });
        }

        seekSlider.addEventListener('input', () => {
          currentTimeContainer.textContent = calculateTime(seekSlider.value);
          if(!audio.paused) {
            cancelAnimationFrame(raf);
          }
        });

        seekSlider.addEventListener('change', () => {
          audio.currentTime = seekSlider.value;
          if(!audio.paused) {
            requestAnimationFrame(whilePlaying);
          }
        });

      })

  //   }
  // }

}(jQuery, Drupal));
/* eslint-enable */
